/**
 * 会员分析统计
 * lixian
 */
const api = [
  {
    name: 'summary',
    method: 'GET',
    desc: '会员分析统计页面',
    path: '/analysis/summary',
    mock: false
  },
  {
    name: 'getOrg',
    method: 'GET',
    desc: '获取会员业务开通信息',
    path: '/analysis/getOrg',
    mock: false
  }
]

export default {
  BASE_URL: '/member',
  api
}



// WEBPACK FOOTER //
// ./src/api/apis/member/statistics.js